export default __webpack_public_path__ + "c339ff504121f060e736a483c1440eef.png";